import * as angular from 'angular';
import { ConditionService } from '../../../shared/condition.service';
import { valuesExpressionIsValid } from '../../../scripts/services/validations';

export class CreateDisplayConditionController implements ng.IController {
  /* tslint:disable */
  $onInit = () => {};
  /* tslint:enable */
  private allowedDisplayConditions: any = [];
  private selectedCondition;
  private modelName: string;
  private selectedTargetGroup: any = {};
  private availableTargetGroups;
  private isEditMode: boolean = false;
  private conditionList;
  private conditionIndexInList;
  private originalCondition;
  private editLabel: string;
  private editButtonLabel: string;
  private processVariableValue: string = "";

  /* @ngInject */
  constructor(
    private $scope: ng.IScope,
    private $rootScope: ng.IRootScopeService,
    private elementHelper,
    private mappings,
    private ConditionService: ConditionService
  ) {
    this.allowedDisplayConditions = elementHelper.getAllowedDisplayConditions($scope.models.elementCopy);
    if (this.$scope.isRootCondition) {
      this.modelName = 'newDisplayCondition';
    } else {
      this.modelName = 'subNewDisplayCondition';
      this.allowedDisplayConditions = this.allowedDisplayConditions.filter((allowed) => {
        return allowed.displayName !== 'Sichtbar wenn komplexe Bedingung erfüllt ist';
      });
      this.initAvailableTargetGroups();
    }
    this.initListeners();
  }

  private initListeners() {
    let removeConditionHandler = this.$rootScope.$on('removeCondition', () => {
      let condition = this.$scope.models[this.modelName];
      if (condition) {
        this.ConditionService.addGroupNames(condition);
      }
      this.initAvailableTargetGroups();
    });

    let editConditionHandler = this.$rootScope.$on('editCondition', (event, condition, isEditing, conditionList) => {
      if (!isEditing && this.modelName === 'newDisplayCondition') {
        this.editLabel = 'Sichtbarkeitsbedingung bearbeiten';
        this.editButtonLabel = 'Sichtbarkeitsbedingung aktualisieren';
        this.enterEditMode(conditionList, condition);
      } else if (this.modelName === 'subNewDisplayCondition') {
        this.editLabel = 'Unterbedingung bearbeiten';
        this.editButtonLabel = 'Unterbedingung aktualisieren';
        this.enterEditMode(conditionList, condition);
      }
    });

    let updateGroupNamesHandler = this.$rootScope.$on('updateGroupNames', () => this.initAvailableTargetGroups());

    this.$scope.$on('$destroy', removeConditionHandler);
    this.$scope.$on('$destroy', editConditionHandler);
    this.$scope.$on('$destroy', updateGroupNamesHandler);
  }

  private enterEditMode(conditionList, condition) {
    this.isEditMode = true;
    this.conditionList = conditionList;
    this.conditionIndexInList = conditionList.indexOf(condition);
    this.originalCondition = condition;
    this.$scope.models[this.modelName] = angular.copy(condition);
    this.$scope.models[this.modelName].$$editing = false;
    let conditionType = condition['@type'];
    if (conditionType === 'OrCondition') {
      conditionType = 'AndCondition';
    }
    this.selectedCondition = this.allowedDisplayConditions.find(
      (allowed) => allowed.template['@type'] === conditionType
    ).template;
    if (this.selectedCondition['@type'] === 'AndCondition') {
      this.initAvailableTargetGroups();
    }
    if (!this.$scope.isRootCondition) {
      this.selectedTargetGroup = this.availableTargetGroups.slice(1).find((a) => a.conditions === conditionList);
    }
  }

  add() {
    let condition = this.$scope.models[this.modelName];
    if (condition.valuesExpression) {
      if (!valuesExpressionIsValid(condition.values, condition.valuesExpression)) {
        return;
      }

      delete condition.values;
    }
    if (condition.valuesExpression === "") {
      delete condition.valuesExpression;
    }
    if (this.$scope.isRootCondition) {
      this.initializeModelDisplayConditions();
      this.selectedTargetGroup.conditions = this.$scope.models.elementCopy.displayConditions;
    }

    if (this.selectedTargetGroup.isNew) {
      condition = { '@type': 'AndCondition', conditions: [condition], $$groupName: this.getGroupName() };
    }

    if (!this.isEditMode) {
      this.selectedTargetGroup.conditions.push(condition);
    } else {
      if (this.selectedTargetGroup.conditions !== this.conditionList) {
        this.selectedTargetGroup.conditions.push(condition);
        this.conditionList.splice(this.conditionIndexInList, 1);
      } else {
        this.conditionList[this.conditionIndexInList] = condition;
      }
    }

    if (!this.$scope.isRootCondition) {
      this.initAvailableTargetGroups();
    }

    this.resetSelection();
  }

  abort() {
    this.originalCondition.$$editing = false;
    this.resetSelection();
  }

  private getGroupName() {
    return (
      'Gruppe ' +
      (this.selectedTargetGroup.conditions.filter((c) => c['@type'] === 'AndCondition' || c['@type'] === 'OrCondition')
        .length +
        1)
    );
  }

  private resetSelection() {
    this.$scope.models[this.modelName] = null;
    this.selectedTargetGroup = {};
    this.selectedCondition = null;
    this.isEditMode = false;
    this.$rootScope.$emit('stopEditing', this.modelName === 'subNewDisplayCondition');
  }

  private initializeModelDisplayConditions() {
    if (!this.$scope.models.elementCopy.displayConditions) {
      this.$scope.models.elementCopy.displayConditions = [];
    }
  }

  setNewDisplayConditionType() {
    this.$scope.models[this.modelName] = angular.copy(this.selectedCondition);
  }

  private initAvailableTargetGroups() {
    if (this.$scope.models.newDisplayCondition) {
      this.availableTargetGroups = [
        {
          name: 'Neue Gruppe',
          conditions: this.$scope.models.newDisplayCondition.conditions,
          isNew: true
        }
      ];
      this.ConditionService.findTargetGroups(
        this.$scope.models.newDisplayCondition.conditions,
        this.availableTargetGroups
      );
    }
  }

  isButtonDisabled() {
    let model = this.$scope.models[this.modelName];
    if (!model) {
      return true;
    }
    let enabled = model;
    if (!this.$scope.isRootCondition) {
      enabled = enabled && this.selectedTargetGroup.conditions;
    }
    if (model.conditionFieldKey) {
      enabled = enabled && model.conditionFieldKey.fieldId;
    }
    if (model.conditions) {
      enabled = enabled && this.checkChildren(model.conditions);
    }
    if (model.values) {
      enabled = enabled && model.values.length > 0 && model.values[0] !== '';
    }
    if (model.valuesExpression) {
      enabled = true;
    }

    return !enabled;
  }

  addProcessVariableConditionValue(newValue) {
    let condition = this.$scope.models[this.modelName];
    if (!condition.values.some(value => value === newValue)) {
      condition.values.push(newValue);
      this.processVariableValue = "";
    }
  }

  deleteProcessVariableConditionValue(valueToDelete) {
    let condition = this.$scope.models[this.modelName];
    this.$scope.models[this.modelName].values =
      condition.values.filter((value) => {
      return value !== valueToDelete;
    });
  }

  checkChildren(conditions) {
    if (conditions.length < 2) {
      return false;
    }
    return conditions.every((c) => {
      if (c.conditions) {
        return this.checkChildren(c.conditions);
      }
      return true;
    });
  }
}
